/** Unique keys for "pacs" module's DTOs */
export enum PacsDtoKeysEnum {
  /** Access card list APIs base filters */
  ACCESS_CARD_FILTERS_DTO = 'pacs/access-card-filters.dto',
  /** Access card response body */
  ACCESS_CARD_FIND_DTO = 'pacs/access-card-find.dto',
  /** Access card create/update request body */
  ACCESS_CARD_FORM_DTO = 'pacs/access-card-form.dto',
  /** Access card partial update request body */
  ACCESS_CARD_PARTIAL_FORM_DTO = 'pacs/access-card-partial-form.dto',
  /** Access cards list with pagination API response body */
  ACCESS_CARD_PAGE_DTO = 'pacs/access-card-page.dto',
  /** Access cards list with pagination API query parameters */
  ACCESS_CARD_QUERY_DTO = 'pacs/access-card-query.dto',
  /** Access card control report common filters */
  ACCESS_CARD_CONTROL_REPORT_FILTERS_DTO = 'pacs/access-card-control-report-filters.dto',
  /** Access card control report registry API response body item */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_ITEM_DTO = 'pacs/access-card-control-report-registry-item.dto',
  /** Access card control report registry API query parameters */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_QUERY_DTO = 'pacs/access-card-control-report-registry-query.dto',
  /** Access card control report statistics API response body item */
  ACCESS_CARD_CONTROL_REPORT_STAT_ITEM_DTO = 'pacs/access-card-control-report-stat-item.dto',
  /** Access card control report statistics API query parameters */
  ACCESS_CARD_CONTROL_REPORT_STAT_QUERY_DTO = 'pacs/access-card-control-report-stat-query.dto',
  /** Coming/Going report internal/external user calendar entry */
  COMING_GOING_REPORT_CALENDAR_ENTRY_DTO = 'pacs/coming-going-report-calendar-entry.dto',
  /** Coming/Going report base filters */
  COMING_GOING_REPORT_FILTERS_DTO = 'pacs/coming-going-report-filters.dto',
  /** Coming/Going report item */
  COMING_GOING_REPORT_ITEM_DTO = 'pacs/coming-going-report-item.dto',
  /** Coming/Going report page response body */
  COMING_GOING_REPORT_PAGE_DTO = 'pacs/coming-going-report-page.dto',
  /** Coming/Going report query parameters */
  COMING_GOING_REPORT_QUERY_DTO = 'pacs/coming-going-report-query.dto',
  /** Base converters list APIs filters */
  CONVERTER_FILTERS_DTO = 'pacs/converter-filters.dto',
  /** Converter response body */
  CONVERTER_FIND_DTO = 'pacs/converter-find.dto',
  /** Converter create/update request body */
  CONVERTER_FORM_DTO = 'pacs/converter-form.dto',
  /** Converter card update request body */
  CONVERTER_CARD_FORM_DTO = 'pacs/converter-card-form.dto',
  /** Converter change password request body */
  CONVERTER_CHANGE_PASSWORD_DTO = 'pacs/converter-change-password.dto',
  /** Converter create request body */
  CONVERTER_CREATE_DTO = 'pacs/converter-create.dto',
  /** "Iron Logic" converter settings response body */
  CONVERTER_ICON_LOGIC_FIND_DTO = 'pacs/converter-icon-logic-find.dto',
  /** Converter events invertion settings */
  CONVERTER_INVERT_EVENTS_DTO = 'pacs/converter-invert-events.dto',
  /** Converter list with pagination API response body */
  CONVERTER_PAGE_DTO = 'pacs/converter-page.dto',
  /** Converter ping settings */
  CONVERTER_PING_SETTINGS_DTO = 'pacs/converter-ping-settings.dto',
  /** Converter list API query parameters */
  CONVERTER_QUERY_DTO = 'pacs/converter-query.dto',
  /** Converter cards reading settings response body */
  CONVERTER_READ_CARDS_FIND_DTO = 'pacs/converter-read-cards-find.dto',
  /** Converter cards reading settings create/update request body */
  CONVERTER_READ_CARDS_FORM_DTO = 'pacs/converter-read-cards-form.dto',
  /** Test mock converter settings response body */
  CONVERTER_TEST_MOCK_FIND_DTO = 'pacs/converter-test-mock-find.dto',
  /** User access converter request body */
  CONVERTER_ACCESS_PARAM_DTO = 'pacs/converter-access-param.dto',
  /** Group access converter request body */
  CONVERTER_ACCESS_GROUP_PARAM_DTO = 'pacs/converter-access-group-param.dto',
  /** Converter time zone body */
  CONVERTER_TIMEZONE_FIND_DTO = 'pacs/converter-timezone-find.dto',
  /** Converter reset time zone query parameters */
  CONVERTER_TIMEZONE_QUERY_DTO = 'pacs/converter-timezone-query.dto',
  /** Converter set timezone request body */
  CONVERTER_TIMEZONE_FORM_DTO = 'pacs/converter-timezone-form.dto',
  /** Converter single timezone request body */
  CONVERTER_TIMEZONE_SINGLE_FORM_DTO = 'pacs/converter-timezone-single-form.dto',
  /** Converter lock settings response body */
  CONVERTER_LOCK_SETTINGS_FIND_DTO = 'pacs/converter-lock-settings-find.dto',
  /** Converter lock settings request body */
  CONVERTER_LOCK_SETTINGS_FORM_DTO = 'pacs/converter-lock-settings-form.dto',
  /** Send command to "Iron Logic" converter API request body */
  IRON_LOGIC_COMMAND_FORM_DTO = 'pacs/iron-logic-command-form.dto',
  /** Response body of queued command from "FRM" to "Iron Logic" */
  IRON_LOGIC_COMMAND_QUEUE_FIND_DTO = 'pacs/iron-logic-command-queue-find.dto',
  /** "Iron Logic" devices queued commands page response body */
  IRON_LOGIC_COMMAND_QUEUE_PAGE_DTO = 'pacs/iron-logic-command-queue-page.dto',
  /** "Iron Logic" devices queued commands page API query parameters */
  IRON_LOGIC_COMMAND_QUEUE_QUERY_DTO = 'pacs/iron-logic-command-queue-query.dto',
  /** "Iron Logic" devices repeat commands API query parameters */
  IRON_LOGIC_COMMAND_REPEAT_EXPIRED_QUERY_DTO = 'pacs/iron-logic-command-repeat-expired-query.dto',
  /** "Iron Logic" devices incoming messages history log delete query parameters */
  IRON_LOGIC_MESSAGES_LOG_DELETE_DTO = 'pacs/iron-logic-messages-log-delete.dto',
  /** "Iron Logic" devices incoming messages history entry response body */
  IRON_LOGIC_MESSAGES_LOG_FIND_DTO = 'pacs/iron-logic-messages-log-find.dto',
  /** "Iron Logic" devices incoming messages history entries slice response body */
  IRON_LOGIC_MESSAGES_LOG_PAGE_DTO = 'pacs/iron-logic-messages-log-page.dto',
  /** "Iron Logic" devices incoming messages history entries filters and settings */
  IRON_LOGIC_MESSAGES_LOG_QUERY_DTO = 'pacs/iron-logic-messages-log-query.dto',
  /** Logging events report API request body */
  EQUIPMENT_LOG_FORM_DTO = 'pacs/equipment-log-form.dto',
  /** Logging events report API responce body */
  EQUIPMENT_LOG_FIND_DTO = 'pacs/equipment-log-find.dto',
  /** Logging events report list with pagination API response body */
  EQUIPMENT_LOG_PAGE_DTO = 'pacs/equipment-log-page.dto',
  /** Logging events report list API query parameters */
  EQUIPMENT_LOG_QUERY_DTO = 'pacs/equipment-log-query.dto',
  /** Logging events report list APIs filters */
  EQUIPMENT_LOG_FILTERS_DTO = 'pacs/equipment-log-filters.dto',
  /** Logging photo-verification report list API query parameters */
  EQUIPMENT_LOG_PHOTO_VERIFICATION_QUERY_DTO = 'pacs/equipment-log-photo-verification-query.dto',
  /** Logging photo-verification report list with pagination API response body */
  EQUIPMENT_LOG_PAGE_PHOTO_VERIFICATION_DTO = 'pacs/equipment-log-page-photo-verification.dto',
  /** Logging photo-verification report list with pagination API response body */
  EQUIPMENT_LOG_FIND_PHOTO_VERIFICATION_DTO = 'pacs/equipment-log-find-photo-verification.dto',
  /** Logging photo-verification report list APIs filters */
  EQUIPMENT_LOG_PHOTO_VERIFICATION_FILTERS_DTO = 'pacs/equipment-log-photo-verification-filters.dto',
  /** "NetPing" find many API own filters */
  NET_PING_DEVICE_FILTERS_DTO = 'pacs/net-ping-device-filters.dto',
  /** "NetPing" find many API query parameters */
  NET_PING_DEVICE_FIND_MANY_QUERY_DTO = 'pacs/net-ping-device-find-many-query.dto',
  /** "NetPing" device find one API query parameters */
  NET_PING_DEVICE_FIND_ONE_QUERY_DTO = 'pacs/net-ping-device-find-one-query.dto',
  /** "NetPing" device response body */
  NET_PING_DEVICE_FIND_DTO = 'pacs/net-ping-device-find.dto',
  /** "NetPing" device create and update APIs request body */
  NET_PING_DEVICE_FORM_DTO = 'pacs/net-ping-device-form.dto',
  /** "NetPing" find many API response body */
  NET_PING_DEVICE_PAGE_DTO = 'pacs/net-ping-device-page.dto',
}
